import { render, staticRenderFns } from "./VoiceAnimation.vue?vue&type=template&id=18a5c4d3&scoped=true"
import script from "./VoiceAnimation.vue?vue&type=script&lang=js"
export * from "./VoiceAnimation.vue?vue&type=script&lang=js"
import style0 from "./VoiceAnimation.vue?vue&type=style&index=0&id=18a5c4d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a5c4d3",
  null
  
)

export default component.exports